export default "__VITE_ASSET__BUhjhGVe__"